const __WEBPACK_NAMESPACE_OBJECT__ = window["bonnet-webcomponent-@atc/react-device"];